import { Component, Suspense } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import * as ACT from './actions'
import s from './Dashboard.scss'
import '!style-loader!css-loader!react-grid-layout/css/styles.css' // eslint-disable-line
import '!style-loader!css-loader!react-resizable/css/styles.css' // eslint-disable-line
import { Responsive, WidthProvider } from 'react-grid-layout'
import Select from 'react-select'
import { Button } from 'reactstrap'
import difference from 'lodash/difference'
import { FaTimes, FaLock, FaLockOpen } from 'react-icons/fa'
import isEqual from 'lodash/isEqual'
import { DictionaryDashboard, AllDashboardComponent } from './DictionaryDashboard'
import { PageTitle } from 'components/common/PageTitle'
import { getUser, isAdmin } from 'utils/authService'

const officesOptions = []
officesOptions.push({ value: 'allOffices', label: 'All Teams' })

const ResponsiveGridLayout = WidthProvider(Responsive)

const defaultProps = {
  className: 'layout',
  breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
  cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
  rowHeight: 20
}

const getOptions = layouts => {
  const allComponents = Object.keys(AllDashboardComponent)
  const options = []
  let layoutsComponents = []
  if (Object.keys(layouts).length) {
    layoutsComponents = layouts.lg.map(el => el.i)
  }
  const optionsComponents = difference(allComponents, layoutsComponents)
  for (let i = 0; i < optionsComponents.length; i++) {
    options.push({
      value: optionsComponents[i],
      label: AllDashboardComponent[optionsComponents[i]].label
    })
  }
  return options
}

let dashboardRefresh = null

@connect(({ dashboard, users, login }) => {
  return {
    dashboard,
    users,
    login
  }
})
class DashboardContainer extends Component {
  state = {
    layouts: {},
    options: [],
    selectedOption: null,
    layoutLocked: true,
    isOverview: false,
    users: [],
    usersOptions: [],
    valueOfficesOptions: null,
    valueUsersOptions: null,
    officesDisabled: false,
    usersDisabled: false,
    officeId: null,
    userId: null,
    firstRender: true
  }

  componentDidMount() {
    dashboardRefresh = setInterval(() => this.refreshBoard(this.state.layouts), 5 * 60 * 1000)
    this.props.dispatch({ type: ACT.LAYOUT_FETCH_REQUESTED })
    this.props.dispatch({ type: ACT.USERS_FETCH_REQUESTED })
    this.props.dispatch({
      type: ACT.OVERVIEW_USER_FETCH_REQUESTED,
      payload: {
        userId: getUser().id
      }
    })
  }

  async componentDidUpdate(prevProps) {
    const { layouts } = this.props.dashboard
    const { users } = this.props.users

    if (this.state.usersOptions.length && this.state.firstRender) {
      this.initSelections()
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        firstRender: false
      })
    }
    if (this.state.usersOptions.length === 0 && users.length) {
      this.setUsers(users)
    }
    if (!isEqual(prevProps.dashboard.layouts, layouts) || !this.state.layouts.lg) {
      if (layouts.content) {
        const content = JSON.parse(layouts.content)
        const overviewArray = content.lg.filter(
          widgets =>
            widgets.i === 'new' ||
            widgets.i === 'estimating' ||
            widgets.i === 'followUp' ||
            widgets.i === 'awarded' ||
            widgets.i === 'won' ||
            widgets.i === 'lost'
        )
        if (overviewArray.length) {
          this.setIsOverview(true)
        } else {
          this.setIsOverview(false)
        }
        this.setDashboard(content, getOptions(content))
      }
    }
  }

  componentWillUnmount() {
    clearInterval(dashboardRefresh)
  }

  refreshBoard = layouts => {
    const { valueOfficesOptions, valueUsersOptions } = this.state
    const officeId =
      (valueOfficesOptions && valueOfficesOptions.value) ||
      (valueOfficesOptions && valueOfficesOptions[0] && valueOfficesOptions[0].value) ||
      'allOffices'
    const userId =
      (valueUsersOptions && valueUsersOptions.value) ||
      (valueUsersOptions && valueUsersOptions[0] && valueUsersOptions[0].value) ||
      'allUsers'

    if (layouts.lg) {
      const isOverview = layouts.lg.filter(
        el =>
          el.i === 'new' ||
          el.i === 'estimating' ||
          el.i === 'followUp' ||
          el.i === 'awarded' ||
          el.i === 'won' ||
          el.i === 'lost'
      )
      if (isOverview.length !== 0) {
        if (officeId === 'allOffices') {
          this.props.dispatch({
            type: ACT.OVERVIEW_USER_FETCH_REQUESTED,
            payload: { ...(userId !== 'allUsers' ? { userId } : {}) }
          })
        } else if (userId === 'allUsers') {
          this.props.dispatch({
            type: ACT.OVERVIEW_OFFICE_FETCH_REQUESTED,
            payload: { office: officeId }
          })
        }
      }

      const isProposalsInReview = layouts.lg.filter(el => el.i === 'proposalsInReview')
      if (isProposalsInReview.length !== 0) {
        this.props.dispatch({
          type: ACT.GET_PROPOSALS_IN_REVIEW_FETCH_REQUESTED
        })
      }

      const isProposalsForReview = layouts.lg.filter(el => el.i === 'proposalsForReview')
      if (isProposalsForReview.length !== 0) {
        this.props.dispatch({
          type: ACT.PROPOSALS_FOR_REVIEW_FETCH_REQ
        })
      }

      const isProposalsToReview = layouts.lg.filter(el => el.i === 'proposalsToReview')
      if (isProposalsToReview.length !== 0) {
        this.props.dispatch({
          type: ACT.PROPOSALS_TO_REVIEW_FETCH_REQ
        })
      }

      const isProposalsUpdate = layouts.lg.filter(el => el.i === 'proposalsUpdate')
      if (isProposalsUpdate.length !== 0) {
        this.props.dispatch({
          type: ACT.PROPOSALS_UPDATE_FETCH_REQ
        })
      }

      const isProposalsClient = layouts.lg.filter(el => el.i === 'proposalsClient')
      if (isProposalsClient.length !== 0) {
        this.props.dispatch({
          type: ACT.PROPOSALS_CLIENT_FETCH_REQ
        })
      }

      const isMyTasks = layouts.lg.filter(el => el.i === 'myTasks')
      if (isMyTasks.length !== 0) {
        this.props.dispatch({
          type: ACT.MY_TASKS_FETCH_REQ,
          payload: {
            userId: userId ? (userId !== 'allUsers' ? userId : '') : getUser().id
          }
        })
      }

      const isMyActive = layouts.lg.filter(el => el.i === 'myActive')
      if (isMyActive.length !== 0) {
        this.props.dispatch({
          type: ACT.MY_ACTIVE_FETCH_REQ
        })
      }
    }
  }

  setDashboard = (layouts, options) => {
    this.setState({ layouts, options })
  }

  setIsOverview = isOverview => {
    this.setState({ isOverview })
  }

  setUsers = users => {
    const usersSaved = []
    usersSaved.push({ value: 'allUsers', label: 'All Users', office: null })
    users.map(el =>
      usersSaved.push({
        value: el.id,
        label: el.userName,
        teams: el.teams
      })
    )
    this.setState({ usersOptions: usersSaved, users: usersSaved })
  }

  saveDashboard = layouts => {
    this.props.dispatch({
      type: ACT.LAYOUT_SAVE_REQUESTED,
      payload: { content: layouts }
    })
  }

  onLayoutChange = (layout, layouts) => {
    layouts = JSON.parse(JSON.stringify(layouts))
    if (!isEqual(layouts, this.state.layouts) && !this.state.layoutLocked) {
      this.saveDashboard(layouts)
      this.setDashboard(layouts, getOptions(layouts))
    }
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption })
  }

  renderComponent = (componentName, typeValue) => {
    const { valueOfficesOptions, valueUsersOptions, layoutLocked } = this.state
    const TagName = componentName

    const officeId =
      (valueOfficesOptions && valueOfficesOptions.value) ||
      (valueOfficesOptions && valueOfficesOptions[0] && valueOfficesOptions[0].value) ||
      'allOffices'
    const userId =
      (valueUsersOptions && valueUsersOptions.value) ||
      (valueUsersOptions && valueUsersOptions[0] && valueUsersOptions[0].value) ||
      'allUsers'
    if (typeValue) {
      return (
        <TagName
          type={typeValue}
          officeId={officeId}
          userId={userId}
          isAdmin={isAdmin()}
          layoutLocked={layoutLocked}
        />
      )
    } else {
      return <TagName />
    }
  }

  addComponent = () => {
    const { value } = this.state.selectedOption
    let { layouts, options } = this.state
    const layoutKeys = Object.keys(layouts)
    options = options.filter(el => el.value !== value)
    for (let i = 0; i < layoutKeys.length; i++) {
      layouts[layoutKeys[i]].push({
        w: AllDashboardComponent[value].width,
        h: AllDashboardComponent[value].height,
        x: 0,
        y: 1000,
        i: value
      })
    }
    defaultProps.breakpoints = { lg: 1201, md: 997, sm: 769, xs: 481, xxs: 1 }
    this.setState({ layouts, options, selectedOption: null })
  }

  removeComponent = component => {
    const { layouts, options } = this.state
    const layoutKeys = Object.keys(layouts)
    options.push({
      value: component,
      label: AllDashboardComponent[component].label
    })
    for (let i = 0; i < layoutKeys.length; i++) {
      let arr = []
      arr = layouts[layoutKeys[i]].filter(el => el.i !== component)
      layouts[layoutKeys[i]] = arr
    }
    defaultProps.breakpoints = { lg: 1201, md: 997, sm: 769, xs: 481, xxs: 1 }
    this.setState({ layouts, options })
  }

  onBreakpointChange = () => {
    defaultProps.breakpoints = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }
  }

  updateLockLayout = isLocked => {
    const { layoutLocked } = this.state
    if (layoutLocked !== isLocked) {
      this.setState({ layoutLocked: isLocked })
    }
  }

  initSelections = () => {
    const { usersOptions } = this.state
    const userId = getUser().id
    if (userId) {
      const loggedUser = usersOptions.filter(el => el.value === userId)
      if (isAdmin()) {
        this.setState({
          valueUsersOptions: loggedUser
        })
      } else {
        this.setState({
          valueUsersOptions: loggedUser,
          officesDisabled: true,
          usersDisabled: true
        })
      }
    }
  }

  handleOfficeChange = office => {
    const { id } = getUser()

    this.setState({ valueOfficesOptions: office, valueUsersOptions: null })
    if (office.value === 'allOffices') {
      this.setState({ officeId: null, userId: null })
      this.props.dispatch({
        type: ACT.OVERVIEW_USER_FETCH_REQUESTED,
        payload: { userId: isAdmin() ? 0 : id }
      })
    } else {
      this.setState({ officeId: office.value, userId: null })
      this.props.dispatch({
        type: ACT.OVERVIEW_OFFICE_FETCH_REQUESTED,
        payload: { office: office.value }
      })
    }
  }

  handleUserChange = user => {
    const { id } = getUser()

    this.setState({ valueUsersOptions: user, valueOfficesOptions: null })
    if (user.value === 'allUsers') {
      this.setState({ usersOptions: this.state.users, officeId: null, userId: null })
      this.props.dispatch({
        type: ACT.OVERVIEW_USER_FETCH_REQUESTED,
        payload: { userId: isAdmin() ? 0 : id }
      })
    } else {
      this.setState({ officeId: null, userId: user.value })
      this.props.dispatch({
        type: ACT.OVERVIEW_USER_FETCH_REQUESTED,
        payload: { userId: user.value }
      })
    }

    this.props.dispatch({
      type: ACT.MY_TASKS_FETCH_REQ,
      payload: {
        userId: user.value ? (user.value !== 'allUsers' ? user.value : '') : id
      }
    })
  }

  render() {
    const {
      options,
      layouts,
      selectedOption,
      layoutLocked,
      usersOptions,
      isOverview,
      // valueOfficesOptions,
      valueUsersOptions,
      // officesDisabled,
      usersDisabled
    } = this.state
    return (
      <div style={{ marginBottom: 50 }}>
        <PageTitle view="Dashboard" />
        <div className={s.topWrapper}>
          <div className={s.manageWidgetWrapper}>
            <Select
              isSearchable
              placeholder="Select a widget"
              name="widgets"
              value={selectedOption}
              onChange={this.handleChange}
              options={[...options]}
              className={s.selectWidget}
              noOptionsMessage={() => 'All available Widgets are on Dashboard'}
              isDisabled={layoutLocked}
            />
            <Button
              onClick={() => this.addComponent()}
              className={s.addWidget}
              disabled={!selectedOption}
            >
              Add Widget on Dashboard
            </Button>
          </div>
          {isOverview && !!usersOptions.length && (
            <div className={s.pipelineWrapper}>
              {/* <Select
                className={s.officesOptions}
                value={valueOfficesOptions}
                options={officesOptions}
                onChange={this.handleOfficeChange}
                placeholder="Select Team"
                isDisabled={officesDisabled}
              /> */}

              <Select
                className={s.usersOptions}
                value={valueUsersOptions}
                options={usersOptions}
                onChange={this.handleUserChange}
                placeholder="Select User"
                isDisabled={usersDisabled}
              />
            </div>
          )}
          <div className={s.setLockWrapper}>
            <FaLock
              onClick={() => this.updateLockLayout(true)}
              className={cn(s.lockIcon, layoutLocked ? s.lockSelected : s.lockNotSelected)}
            />
            <FaLockOpen
              onClick={() => this.updateLockLayout(false)}
              className={cn(s.lockIcon, !layoutLocked ? s.lockSelected : s.lockNotSelected)}
            />
          </div>
        </div>
        <ResponsiveGridLayout
          {...defaultProps}
          containerPadding={[50, 0]}
          layouts={layouts}
          onBreakpointChange={this.onBreakpointChange}
          onLayoutChange={(layout, layouts) => this.onLayoutChange(layout, layouts)}
          isDraggable={!layoutLocked}
          isResizable={!layoutLocked}
        >
          {layouts.lg &&
            layouts.lg
              .filter(el => AllDashboardComponent[el.i])
              .map(el => (
                <div className={s.widgetStyle} key={el.i}>
                  <Suspense fallback={<span />}>
                    {this.renderComponent(
                      DictionaryDashboard[AllDashboardComponent[el.i].componentName],
                      AllDashboardComponent[el.i].type,
                      AllDashboardComponent[el.i].componentName
                    )}
                  </Suspense>
                  <span
                    className={!layoutLocked ? s.removeWidget : s.hidden}
                    onClick={() => this.removeComponent(el.i)}
                    onMouseDown={e => e.stopPropagation()}
                  >
                    <FaTimes className={s.removeWidgetIcon} />
                  </span>
                </div>
              ))}
        </ResponsiveGridLayout>
      </div>
    )
  }
}

export default DashboardContainer
